import React from "react";
import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const DMSComponent = () => {
  return (
    <>
      <Helmet>
        <title>DMS | Admin</title>
      </Helmet>
      <Outlet />
    </>
  );
};

export default DMSComponent;
